import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismTooltip } from '@mylighthouse/prism-ember';

interface MarketTotalRevenueCellsTdExportSignature {
  Args: {
    cellData: {
      handleExport: () => void;
      tooltipMessage?: string;
    };
  };
}

const MarketTotalRevenueCellsTdExport = <template>
  <span class="td-export-container">
    <PrismButton
      @buttonType="ghost"
      @icon="excel-export"
      @onClick={{@cellData.handleExport}}
      @size="small"
      aria-label={{if @cellData.tooltipMessage @cellData.tooltipMessage}}
      class="td-export"
    />

    {{#if @cellData.tooltipMessage}}
      <PrismTooltip @text={{@cellData.tooltipMessage}} />
    {{/if}}
  </span>
</template> satisfies TOC<MarketTotalRevenueCellsTdExportSignature>;

export default MarketTotalRevenueCellsTdExport;
